module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-31.6ec59bde.png";